<template>
  <div v-if="executor || randomExecutor" class="trip-main">
    <modal-dialog v-model:show="showModal">
      <div class="modal-content">
        <h4>Отправить данные в ТМС?</h4>
        <label v-if="sendConfirm === 'candidate'" class="send-as-own-option">
          <input v-model="sendAsOwn" type="checkbox" />
          <span>Отправлять как собственный</span>
        </label>
        <p v-if="sendConfirm === 'candidate' && sendAsOwn" class="send-as-own-hint">
          Водитель, автомобиль и прицеп будут отправлены как транспорт АЛТ
        </p>
        <div>
          <button @click="sendToTMS" :disabled="sendTmsLoading" class="save-button">
            {{ sendTmsLoading ? 'Отправка...' : 'Да' }}
          </button>
          <button @click="showModal=false" class="delete-btn">Нет</button>
        </div>
      </div>
    </modal-dialog>
    <modal-dialog v-model:show="showResyncModal">
      <div class="resync-modal-content">
        <h4>⟳ Resync из источника</h4>
        <div class="resync-modal-subtitle">
          Trip {{ trip.trip_id }} · текущий статус: {{ trip.work_status?.name || '—' }}
        </div>

        <div v-if="resyncLoading" class="resync-state resync-state-loading">
          <p>⏳ Получение diff из источника...</p>
        </div>

        <div v-else-if="resyncError" class="resync-state resync-state-error">
          <strong>Ошибка</strong>
          <p>{{ resyncError }}</p>
          <div class="resync-actions">
            <button @click="closeResyncModal" class="delete-btn">Закрыть</button>
          </div>
        </div>

        <div v-else-if="resyncResult" class="resync-result">
          <div v-if="resyncResult.written" class="resync-banner resync-banner-success">
            ✅ Изменения применены к рейсу
          </div>

          <div v-if="resyncResult.matched_executor" class="resync-section">
            <h5>Matched executor</h5>
            <div class="resync-executor-card">
              <strong>
                driver #{{ resyncResult.matched_executor.driver_id || '—' }}
                / car #{{ resyncResult.matched_executor.car_id || '—' }}
                <template v-if="resyncResult.matched_executor.trailer_id">
                  / trailer #{{ resyncResult.matched_executor.trailer_id }}
                </template>
              </strong>
              <span v-if="resyncResult.matched_executor.will_create">будет создан новый executor</span>
              <span v-else-if="resyncResult.matched_executor.template_executor_id">
                template #{{ resyncResult.matched_executor.template_executor_id }}
              </span>
              <span v-else>exact match</span>
            </div>
          </div>

          <div v-if="hasDiff" class="resync-section">
            <h5>Diff (current → planned)</h5>
            <div class="resync-diff">
              <div v-for="field in diffFields" :key="field.key" class="resync-diff-row">
                <span>{{ field.label }}</span>
                <strong>
                  <span class="diff-current">{{ formatValue(field.current) }}</span>
                  <span class="diff-arrow">→</span>
                  <span class="diff-planned">{{ formatValue(field.planned) }}</span>
                </strong>
              </div>
            </div>
          </div>

          <div v-if="resyncResult.applied && resyncResult.applied.length" class="resync-section">
            <h5>Применяемые шаги ({{ resyncResult.applied.length }})</h5>
            <div class="resync-tags">
              <span v-for="step in resyncResult.applied" :key="step" class="resync-tag resync-tag-applied">{{ step }}</span>
            </div>
          </div>

          <div v-if="resyncResult.skipped && resyncResult.skipped.length" class="resync-section">
            <h5>Пропущены ({{ resyncResult.skipped.length }})</h5>
            <div class="resync-tags">
              <span v-for="step in resyncResult.skipped" :key="step" class="resync-tag resync-tag-skipped">{{ step }}</span>
            </div>
          </div>

          <div v-if="resyncResult.warnings && resyncResult.warnings.length" class="resync-section resync-warnings">
            <h5>Предупреждения</h5>
            <ul class="resync-warning-list">
              <li v-for="(w, i) in resyncResult.warnings" :key="i">{{ w }}</li>
            </ul>
          </div>

          <div class="resync-actions">
            <button
              v-if="!resyncResult.written"
              @click="applyResync"
              :disabled="resyncApplying || !canApply"
              class="save-button"
            >
              <span v-if="resyncApplying">⏳ Применяю...</span>
              <span v-else>Применить</span>
            </button>
            <button @click="closeResyncModal" class="delete-btn">
              {{ resyncResult.written ? 'Закрыть' : 'Отмена' }}
            </button>
          </div>
        </div>

        <div v-else class="resync-state">
          <p>Нет данных</p>
          <button @click="closeResyncModal" class="delete-btn">Закрыть</button>
        </div>
      </div>
    </modal-dialog>
    <div class="executor-header">
      <h4 v-if="executor">Исполнитель № {{ executor.id }}</h4>
      <h4 v-else>Случайный исполнитель</h4>
      <button
        v-if="!executor && trip.executor_price"
        class="change-button"
        @click="$emit('assignExecutor')"
      >Назначить исполнителя</button>
      <button
        v-if="executor && !delConfirm"
        @click="delConfirm=true"
        class="delete-btn"
      >Удалить</button>
      <div v-else-if="executor" class="executor-actions">
        <button @click="deleteExecutor" class="save-button">Да</button>
        <button @click="delConfirm=false" class="delete-btn">Нет</button>
      </div>
    </div>
    <TmsSyncedBadge :trip="trip" :executor="executor" />
    <TmsOwnershipNote :executor="executor" />

      <div v-if="executor" class="executor-grid">
      <section class="executor-section">
        <div class="section-header">
          <h5>Автомобиль</h5>
          <div class="section-header-actions">
            <button class="copy-btn" @click="copyCar(executor.car)">Копировать</button>
            <button v-if="!redactCar" class="redact-btn" @click="openClose('redactCar')">Изменить</button>
          </div>
        </div>
        <div class="field-row">
          <span>Марка</span>
          <strong v-if="!redactCar">{{ getBrandName(executor.car) }}</strong>
          <input v-else class="form-input" v-model="forms.cars.brand_name">
        </div>
        <div class="field-row">
          <span>Номер</span>
          <strong v-if="!redactCar">{{ executor.car?.number || '-' }}</strong>
          <input v-else class="form-input" v-model="forms.cars.number">
        </div>
        <div class="field-row">
          <span>Вин</span>
          <strong v-if="!redactCar">{{ executor.car?.vin || '-' }}</strong>
          <input v-else class="form-input" v-model="forms.cars.vin">
        </div>
          <div class="field-row">
            <span>Телефон</span>
            <strong v-if="!redactCar">{{ executor.car?.ownerPhone || '-' }}</strong>
            <input v-else class="form-input" v-model="forms.cars.ownerPhone">
          </div>
          <div class="field-row">
            <span>Техпаспорт</span>
            <strong>{{ executor.car?.techPassport || '-' }}</strong>
          </div>
          <div class="field-row">
            <span>TMS ID</span>
            <strong><a v-if="executor.car?.tms_id" class="tms-link" :href="tmsObjectUrl('vehicles', executor.car.tms_id)" target="_blank" rel="noopener noreferrer">{{ executor.car.tms_id }}</a><span v-else>-</span></strong>
          </div>
          <div class="field-row">
            <span>GLONASS</span>
            <strong>{{ booleanLabel(executor.car?.glonass) }}</strong>
          </div>
        <div v-if="redactCar" class="section-actions">
          <button class="redact-btn" @click="openClose('redactCar')">Отмена</button>
          <button class="redact-btn" @click="saveForm('cars')">Сохранить</button>
        </div>
      </section>

      <section class="executor-section">
        <div class="section-header">
          <h5>{{ executor.trailer ? 'Прицеп' : 'Прицеп отсутствует' }}</h5>
          <div class="section-header-actions">
            <button v-if="executor.trailer" class="copy-btn" @click="copyTrailer(executor.trailer)">Копировать</button>
            <button v-if="executor.trailer && !redactTrailer" class="redact-btn" @click="openClose('redactTrailer')">Изменить</button>
          </div>
        </div>
        <template v-if="executor.trailer">
          <div class="field-row">
            <span>Марка</span>
            <strong v-if="!redactTrailer">{{ getBrandName(executor.trailer) }}</strong>
            <input v-else class="form-input" v-model="forms.trailers.brand_name">
          </div>
            <div class="field-row">
              <span>Номер</span>
              <strong v-if="!redactTrailer">{{ executor.trailer.number }}</strong>
              <input v-else class="form-input" v-model="forms.trailers.number">
            </div>
            <div class="field-row">
              <span>VIN</span>
              <strong>{{ executor.trailer.vin || '-' }}</strong>
            </div>
            <div class="field-row">
              <span>Тип</span>
              <strong>{{ executor.trailer.trailer_type_id || '-' }}</strong>
            </div>
            <div class="field-row">
              <span>TMS ID</span>
              <strong><a v-if="executor.trailer.tms_id" class="tms-link" :href="tmsObjectUrl('trailers', executor.trailer.tms_id)" target="_blank" rel="noopener noreferrer">{{ executor.trailer.tms_id }}</a><span v-else>-</span></strong>
            </div>
          <div v-if="redactTrailer" class="section-actions">
            <button class="redact-btn" @click="openClose('redactTrailer')">Отмена</button>
            <button class="redact-btn" @click="saveForm('trailers')">Сохранить</button>
          </div>
        </template>
      </section>

      <section class="executor-section">
        <div class="section-header">
          <h5>Водитель</h5>
          <div class="section-header-actions">
            <button class="copy-btn" @click="copyDriver(executor.driver)">Копировать</button>
            <button v-if="!redactDriver" class="redact-btn" @click="openClose('redactDriver')">Изменить</button>
          </div>
        </div>
        <div class="field-row">
          <span>Фамилия</span>
          <strong>{{ executor.driver?.last_name || '-' }}</strong>
        </div>
        <div class="field-row">
          <span>Имя</span>
          <strong>{{ executor.driver?.first_name || '-' }}</strong>
        </div>
        <div class="field-row">
          <span>Отчество</span>
          <strong>{{ executor.driver?.surname || '-' }}</strong>
        </div>
        <div class="field-row">
          <span>Телефон</span>
          <strong v-if="!redactDriver">{{ executor.driver?.phone || '-' }}</strong>
          <input v-else class="form-input" v-model="forms.drivers.phone">
        </div>
        <div class="field-row">
          <span>Д/Р</span>
          <strong v-if="!redactDriver">{{ executor.driver?.birthday || '-' }}</strong>
          <input v-else class="form-input" v-model="forms.drivers.birthday">
        </div>
        <div class="field-row">
          <span>Паспорт</span>
          <strong v-if="!redactDriver">{{ executor.driver?.passport || '-' }}</strong>
          <input v-else class="form-input" v-model="forms.drivers.passport">
        </div>
        <div class="field-row">
          <span>Кем выдан</span>
          <strong v-if="!redactDriver">{{ executor.driver?.passport_issued || '-' }}</strong>
          <input v-else class="form-input" v-model="forms.drivers.passport_issued">
        </div>
        <div class="field-row">
          <span>Дата выдачи</span>
          <strong v-if="!redactDriver">{{ executor.driver?.passport_date || '-' }}</strong>
          <input v-else class="form-input" v-model="forms.drivers.passport_date">
        </div>
        <div class="field-row">
          <span>ВУ</span>
          <strong v-if="!redactDriver">{{ executor.driver?.license || '-' }}</strong>
          <input v-else class="form-input" v-model="forms.drivers.license">
        </div>
        <div class="field-row">
          <span>ИНН</span>
          <div v-if="redactDriver" class="inn-edit-cell">
            <input class="form-input" v-model="forms.drivers.inn">
          </div>
          <div v-else class="inn-status-cell">
            <template v-if="driverInnChecking">
              <span class="inn-checking">{{ driverInnCheckingText }}</span>
              <span v-if="executor.driver?.generated_inn || executor.driver?.inn" class="inn-fallback-small">
                сейчас: {{ executor.driver?.inn || executor.driver?.generated_inn }}
              </span>
            </template>
            <template v-else-if="executor.driver?.inn && executor.driver?.inn_check_status === 'done'">
              <strong>✅ {{ executor.driver?.inn }}</strong>
              <span class="inn-badge inn-badge-success" title="Получен из ФНС">ФНС</span>
              <span v-if="executor.driver?.inn_check_at" class="inn-meta">{{ formatInnDate(executor.driver?.inn_check_at) }}</span>
            </template>
            <template v-else-if="!executor.driver?.inn && executor.driver?.generated_inn && executor.driver?.inn_check_status === 'done'">
              <strong>⚠️ {{ executor.driver?.generated_inn }}</strong>
              <span class="inn-badge inn-badge-warning" title="ФНС не нашла водителя по паспорту. Используется сгенерированный валидный ИНН.">Сгенерирован</span>
            </template>
            <template v-else-if="executor.driver?.inn_check_status === 'failed'">
              <strong>❌ {{ executor.driver?.generated_inn || executor.driver?.inn || '—' }}</strong>
              <span class="inn-badge inn-badge-error" :title="executor.driver?.inn_check_error || 'Не удалось проверить'">Не получен</span>
              <button class="inn-link-btn" :disabled="innRecheckBusy" @click="recheckDriverInn">Перепроверить</button>
            </template>
            <template v-else>
              <strong>{{ executor.driver?.generated_inn || executor.driver?.inn || '—' }}</strong>
              <button
                v-if="!executor.driver?.inn && !executor.driver?.generated_inn"
                class="inn-link-btn"
                :disabled="innRecheckBusy"
                @click="recheckDriverInn"
              >Запросить</button>
            </template>
          </div>
        </div>
        <div class="field-row">
          <span>TMS ID</span>
          <strong><a v-if="executor.driver?.tms_id" class="tms-link" :href="tmsObjectUrl('drivers', executor.driver.tms_id)" target="_blank" rel="noopener noreferrer">{{ executor.driver.tms_id }}</a><span v-else>-</span></strong>
        </div>
        <div class="field-row">
          <span>Проверка ИНН</span>
          <strong>{{ innStatusLabel(executor.driver) }}</strong>
        </div>
        <p v-if="executor.driver?.is_random_inn" class="warning-text">Инн сгенерирован случайно</p>
        <div v-if="redactDriver" class="section-actions">
          <button class="redact-btn" @click="openClose('redactDriver')">Отмена</button>
          <button class="redact-btn" @click="saveForm('drivers')">Сохранить</button>
        </div>
      </section>

      <section class="executor-section">
        <div class="section-header">
          <h5>Компания</h5>
          <div class="section-header-actions">
            <button class="copy-btn" @click="copyCompany(executor.company, executor.bank_details)">Копировать</button>
            <button v-if="!redactCompany" class="redact-btn" @click="openClose('redactCompany')">Изменить</button>
          </div>
        </div>
        <div class="field-row">
          <span>Название</span>
          <strong v-if="!redactCompany">{{ executor.company?.name || '-' }}</strong>
          <input v-else class="form-input" v-model="forms.companies.name">
        </div>
        <div class="field-row">
          <span>Директор</span>
          <strong v-if="!redactCompany">{{ executor.company?.director || '-' }}</strong>
          <input v-else class="form-input" v-model="forms.companies.director">
        </div>
        <div class="field-row">
          <span>ОГРН</span>
          <strong v-if="!redactCompany">{{ executor.company?.ogrn || '-' }}</strong>
          <input v-else class="form-input" v-model="forms.companies.ogrn">
        </div>
        <div class="field-row">
          <span>ИНН</span>
          <strong v-if="!redactCompany">{{ executor.company?.inn || '-' }}</strong>
          <input v-else class="form-input" v-model="forms.companies.inn">
        </div>
        <div class="field-row">
          <span>Банк</span>
          <strong v-if="!redactCompany">
            <span v-if="executor.bank_details">{{ executor.bank_details.bank_name }}</span>
            <span v-else>Нет счетов</span>
            <a class="add-link" @click="$router.push('/executors/'+executor.id)">Добавить</a>
          </strong>
          <select v-else class="form-input" v-model="changeBank" @change="updateBank(changeBank)">
            <option v-for="bank in executor.company?.bank_details || []" :key="bank.id" :value="bank.id">{{ bank.bank_name }}</option>
          </select>
        </div>
        <div v-if="redactCompany" class="section-actions">
          <button class="redact-btn" @click="openClose('redactCompany')">Отмена</button>
          <button class="redact-btn" @click="saveForm('companies')">Сохранить</button>
        </div>
        </section>
        <section class="executor-section">
          <div class="section-header">
            <h5>ЭДО</h5>
            <div class="section-header-actions">
              <button v-if="!redactExecutor" class="redact-btn" @click="openClose('redactExecutor')">Изменить</button>
            </div>
          </div>
          <div class="field-row">
            <span>ЭДО ID</span>
            <strong v-if="!redactExecutor">{{ executor.edo_id || '-' }}</strong>
            <input v-else class="form-input" v-model="forms.executors.edo_id">
          </div>
          <div v-if="redactExecutor" class="section-actions">
            <button class="redact-btn" @click="openClose('redactExecutor')">Отмена</button>
            <button class="redact-btn" @click="saveForm('executors')">Сохранить</button>
          </div>
        </section>
      </div>
      <div v-if="executor" class="copy-all-row">
        <button class="copy-btn copy-all-btn" @click="copyAll(executor, 'Исполнитель')">Копировать всё</button>
      </div>

      <div v-if="randomExecutor" class="random-accordion">
      <button class="accordion-toggle" @click="showRandomExecutor = !showRandomExecutor">
        <span>Случайный исполнитель</span>
        <strong>{{ showRandomExecutor ? 'Скрыть' : 'Показать' }}</strong>
      </button>
      <div v-if="showRandomExecutor" class="executor-grid random-executor-grid">
        <section class="executor-section">
          <div class="section-header">
            <h5>Автомобиль заглушки</h5>
            <button class="copy-btn" @click="copyCar(randomExecutor.car, 'Автомобиль заглушки')">Копировать</button>
          </div>
          <div class="field-row">
            <span>Марка</span>
            <strong>{{ getBrandName(randomExecutor.car) }}</strong>
          </div>
          <div class="field-row">
            <span>Номер</span>
            <strong>{{ randomExecutor.car?.number || '-' }}</strong>
          </div>
          <div class="field-row">
            <span>Вин</span>
            <strong>{{ randomExecutor.car?.vin || '-' }}</strong>
          </div>
          <div class="field-row">
            <span>Телефон</span>
            <strong>{{ randomExecutor.car?.ownerPhone || '-' }}</strong>
          </div>
          <div class="field-row">
            <span>Техпаспорт</span>
            <strong>{{ randomExecutor.car?.techPassport || '-' }}</strong>
          </div>
          <div class="field-row">
            <span>TMS ID</span>
            <strong><a v-if="randomExecutor.car?.tms_id" class="tms-link" :href="tmsObjectUrl('vehicles', randomExecutor.car.tms_id)" target="_blank" rel="noopener noreferrer">{{ randomExecutor.car.tms_id }}</a><span v-else>-</span></strong>
          </div>
        </section>

        <section class="executor-section">
          <div class="section-header">
            <h5>{{ randomExecutor.trailer ? 'Прицеп заглушки' : 'Прицеп заглушки отсутствует' }}</h5>
            <button v-if="randomExecutor.trailer" class="copy-btn" @click="copyTrailer(randomExecutor.trailer, 'Прицеп заглушки')">Копировать</button>
          </div>
          <template v-if="randomExecutor.trailer">
            <div class="field-row">
              <span>Марка</span>
              <strong>{{ getBrandName(randomExecutor.trailer) }}</strong>
            </div>
            <div class="field-row">
              <span>Номер</span>
              <strong>{{ randomExecutor.trailer.number || '-' }}</strong>
            </div>
            <div class="field-row">
              <span>VIN</span>
              <strong>{{ randomExecutor.trailer.vin || '-' }}</strong>
            </div>
            <div class="field-row">
              <span>Тип</span>
              <strong>{{ randomExecutor.trailer.trailer_type_id || '-' }}</strong>
            </div>
            <div class="field-row">
              <span>TMS ID</span>
              <strong><a v-if="randomExecutor.trailer.tms_id" class="tms-link" :href="tmsObjectUrl('trailers', randomExecutor.trailer.tms_id)" target="_blank" rel="noopener noreferrer">{{ randomExecutor.trailer.tms_id }}</a><span v-else>-</span></strong>
            </div>
          </template>
        </section>

        <section class="executor-section">
          <div class="section-header">
            <h5>Водитель заглушки</h5>
            <button class="copy-btn" @click="copyDriver(randomExecutor.driver, 'Водитель заглушки')">Копировать</button>
          </div>
          <div class="field-row">
            <span>Фамилия</span>
            <strong>{{ randomExecutor.driver?.last_name || '-' }}</strong>
          </div>
          <div class="field-row">
            <span>Имя</span>
            <strong>{{ randomExecutor.driver?.first_name || '-' }}</strong>
          </div>
          <div class="field-row">
            <span>Отчество</span>
            <strong>{{ randomExecutor.driver?.surname || '-' }}</strong>
          </div>
          <div class="field-row">
            <span>Телефон</span>
            <strong>{{ randomExecutor.driver?.phone || '-' }}</strong>
          </div>
          <div class="field-row">
            <span>Д/Р</span>
            <strong>{{ randomExecutor.driver?.birthday || '-' }}</strong>
          </div>
          <div class="field-row">
            <span>Паспорт</span>
            <strong>{{ randomExecutor.driver?.passport || '-' }}</strong>
          </div>
          <div class="field-row">
            <span>Кем выдан</span>
            <strong>{{ randomExecutor.driver?.passport_issued || '-' }}</strong>
          </div>
          <div class="field-row">
            <span>Дата выдачи</span>
            <strong>{{ randomExecutor.driver?.passport_date || '-' }}</strong>
          </div>
          <div class="field-row">
            <span>ВУ</span>
            <strong>{{ randomExecutor.driver?.license || '-' }}</strong>
          </div>
          <div class="field-row">
            <span>ИНН</span>
            <strong>{{ randomExecutor.driver?.inn || '-' }}</strong>
          </div>
          <div class="field-row">
            <span>TMS ID</span>
            <strong><a v-if="randomExecutor.driver?.tms_id" class="tms-link" :href="tmsObjectUrl('drivers', randomExecutor.driver.tms_id)" target="_blank" rel="noopener noreferrer">{{ randomExecutor.driver.tms_id }}</a><span v-else>-</span></strong>
          </div>
          <p v-if="randomExecutor.driver?.is_random_inn" class="warning-text">Инн сгенерирован случайно</p>
        </section>
      </div>
      <div v-if="showRandomExecutor" class="copy-all-row">
        <button class="copy-btn copy-all-btn" @click="copyAll(randomExecutor, 'Случайный исполнитель')">Копировать всё</button>
      </div>
    </div>

    <div class="integration-statuses">
      <h5>Статусы интеграции</h5>
      <div class="status-grid">
        <div class="status-row">
          <span>Автомобиль</span>
          <strong :class="statusClass(hasExternalNumber(statusCar))">
            {{ hasExternalNumber(statusCar) ? 'Внешний номер получен' : 'Внешний номер не получен' }}
          </strong>
        </div>
        <div class="status-row">
          <span>Прицеп</span>
          <strong v-if="statusTrailer" :class="statusClass(hasExternalNumber(statusTrailer))">
            {{ hasExternalNumber(statusTrailer) ? 'Внешний номер получен' : 'Внешний номер не получен' }}
          </strong>
          <strong v-else>Отсутствует</strong>
        </div>
        <div class="status-row">
          <span>Водитель</span>
          <strong :class="statusClass(hasExternalNumber(statusDriver))">
            {{ hasExternalNumber(statusDriver) ? 'Внешний номер получен' : 'Внешний номер не получен' }}
          </strong>
        </div>
        <div class="status-row">
          <span>Исполнитель</span>
          <strong :class="statusClass(trip.is_tms_candidate || trip.is_tms_failed_candidate)">
            <span v-if="trip.is_candidate_attached">Отправка в процессе</span>
            <span v-else-if="trip.is_tms_candidate">Добавлен в ТМС</span>
            <span v-else-if="trip.is_tms_failed_candidate">Добавлен случайный исполнитель</span>
            <span v-else>Не добавлен в ТМС</span>
          </strong>
        </div>
        <div class="status-row">
          <span>Доверенность</span>
          <strong :class="statusClass(attorneyStatus.success)">
            <span>{{ attorneyStatus.text }}</span>
          </strong>
        </div>
      </div>
    </div>

    <div v-if="executor" class="send-order-block">
      <button
      v-if="!application || !application.is_sent"
      class="save-button"
      :disabled="sendOrderLoading"
      @click="sendOrder"
      >{{ sendOrderLoading ? 'Формирую бланк...' : 'Отправить заявку' }}</button>
    </div>
    
    <div v-if="showTmsBlock" class="tms-button-send">
      <h4>Работа с ТМС</h4>
      <div v-if="sendTmsSuccess" class="flex-row">
        <div class="tms-block-info">
          <div class="send-tms-candidat">
            <h5 v-if="trip.is_candidate_attached">В процессе добавления</h5>
            <h5 v-if="trip.is_tms_candidate">Исполнитель добавлен</h5>
            <h5 v-else-if="trip.is_tms_failed_candidate">Добавлен случайный исполнитель</h5>
            <button 
              @click="confirmed('candidate')"
              class="save-button">
              <span v-if="!trip.is_tms_candidate">Добавить исполнителя</span>
              <span v-else>Добавить нового</span>
            </button>
          </div>
        </div>
        <div>
          <h5 v-if="trip.is_tms_attorney">Доверенность добавлена</h5>
          <h5 v-else-if="!trip.is_tms_attorney && trip.attorney_name">Доверенность отправлена в очередь</h5>
          <button
            v-if="executor.is_success"
            class="save-button" 
            @click="confirmed('attorney')">
            <span v-if="!trip.is_tms_attorney">Загрузить доверенность</span>
            <span v-else>Загрузить повторно</span>
          </button>
          <div v-else>
            <button class="disabled-button" disabled>
              Загрузить доверенность
            </button>
            <div class="attorey-message">
              <p>Нельзя загрузить доверенность,</p>
              <p>подтвердите проверку</p>
              <div>
                <a class="link-executor" @click="$router.push('/executors/'+executor.id)">Исполнителя №: {{executor.id}}</a>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div v-else>
        <p>Не готов к внесению</p>
      </div>

      <div v-if="trip.error_message || tmsLastError" class="tms-error-message">
        <strong>Ошибка отправки в ТМС</strong>
        <TmsLastErrorCard
          v-if="tmsLastError"
          :error="tmsLastError"
          :log-link="tmsLogLink"
        />
        <p v-if="!tmsLastError && trip.error_message">{{ trip.error_message }}</p>
        <small>Исправьте данные в рейсе и повторите отправку исполнителя.</small>
      </div>
    </div>

    <div v-if="isAdmin" class="tms-resync-block">
      <button
        @click="openResyncPreview"
        :disabled="resyncButtonDisabled || resyncLoading"
        class="save-button resync-button"
      >
        <span v-if="resyncLoading">⏳ Загрузка...</span>
        <span v-else>⟳ Resync из источника</span>
      </button>
      <p v-if="resyncButtonDisabled" class="resync-disabled-hint">
        Resync недоступен в статусах «Ждет согласования» и «Закрыт»
      </p>
    </div>
  </div>
</template>

<script>
import { saveExecutorForm } from '@/pages/trip/helpers/saveExecutorForm.mjs'
import { useRoute } from 'vue-router'
import { ref,computed,watch } from 'vue'
import { useStore } from 'vuex';
import { createToaster } from '@meforma/vue-toaster';
import TmsLastErrorCard from '@/components/TmsLastErrorCard.vue';
import TmsSyncedBadge from '@/components/TmsSyncedBadge.vue';
import TmsOwnershipNote from '@/components/TmsOwnershipNote.vue';
import { fetchTmsLastErrorByTrip } from '@/backend/tmsActionLogApi';

const toaster = createToaster();
const TMS_WEB_URL = process.env.VUE_APP_TMS_URL || 'https://napitkivmeste.artlogic-sk.ru';

export default {
  name: 'ExecutorTripInfo',
  components: { TmsLastErrorCard, TmsSyncedBadge, TmsOwnershipNote },
  props: ['trip','executor','randomExecutor'],
  setup(props,{emit}){

    const store = useStore()
    store.dispatch('applications/getApplication',props.trip.id)


    const route = useRoute()

    const redactDriver = ref(false)
    const redactCompany = ref(false)
    const redactTrailer = ref(false)
    const redactCar = ref(false)
    const redactExecutor = ref(false)
    const delConfirm = ref(false)
    const sendConfirm = ref(null)
    const sendAsOwn = ref(false)
    const showModal = ref(false)
    const changeBank = ref(props.executor?.bank_detail_id)
    const showRandomExecutor = ref(!props.executor)

    const showResyncModal = ref(false)
    const resyncLoading = ref(false)
    const resyncApplying = ref(false)
    const resyncResult = ref(null)
    const resyncError = ref(null)

    const isAdmin = computed(() => store.getters['isAdmin'])

    // Backend RESYNC_DISABLED_STATUSES = (4, 7) — «Ждет согласования», «Закрыт»
    const resyncButtonDisabled = computed(() => {
      const statusId = props.trip?.work_status_id ?? props.trip?.work_status?.id
      return statusId === 4 || statusId === 7
    })

    const diffFields = computed(() => {
      const r = resyncResult.value
      if (!r) return []
      const cur = r.current || {}
      const pln = r.planned || {}
      return [
        { key: 'work_status_id', label: 'work_status_id', current: cur.work_status_id, planned: pln.work_status_id },
        { key: 'executor_id', label: 'executor_id', current: cur.executor_id, planned: pln.executor_id },
        { key: 'is_tms_candidate', label: 'is_tms_candidate', current: cur.is_tms_candidate, planned: pln.is_tms_candidate },
        { key: 'is_tms_attorney', label: 'is_tms_attorney', current: cur.is_tms_attorney, planned: pln.is_tms_attorney },
      ]
    })

    const hasDiff = computed(() => {
      const r = resyncResult.value
      return Boolean(r && (r.current || r.planned))
    })

    const canApply = computed(() => {
      const r = resyncResult.value
      return Boolean(r && Array.isArray(r.applied) && r.applied.length > 0)
    })

    function formatResyncValue(v) {
      if (v === undefined || v === null || v === '') return '—'
      if (typeof v === 'boolean') return v ? 'true' : 'false'
      return String(v)
    }

    async function openResyncPreview() {
      if (resyncButtonDisabled.value || resyncLoading.value) return
      showResyncModal.value = true
      resyncLoading.value = true
      resyncError.value = null
      resyncResult.value = null
      try {
        const result = await store.dispatch('tripsResync/resyncTrip', {
          trip_id: props.trip.trip_id,
          dry: true,
        })
        resyncResult.value = result
      } catch (e) {
        resyncError.value = e?.response?.data?.detail || e?.message || 'Не удалось получить diff из источника'
      } finally {
        resyncLoading.value = false
      }
    }

    async function applyResync() {
      if (resyncApplying.value) return
      resyncApplying.value = true
      resyncError.value = null
      try {
        const result = await store.dispatch('tripsResync/resyncTrip', {
          trip_id: props.trip.trip_id,
          dry: false,
        })
        resyncResult.value = result
        if (result?.written) {
          try {
            await store.dispatch('cargos/getTrip', { trip_id: props.trip.id })
          } catch (refreshErr) {
            console.error('[ExecutorTripInfo] cargos/getTrip refresh failed', refreshErr)
          }
        }
      } catch (e) {
        resyncError.value = e?.response?.data?.detail || e?.message || 'Не удалось применить изменения'
      } finally {
        resyncApplying.value = false
      }
    }

    function closeResyncModal() {
      showResyncModal.value = false
      resyncResult.value = null
      resyncError.value = null
    }

    const application = computed(()=>store.state.applications.currentApp)
  
    const correctFormTms = ref({
      inn_driver:'',
      type:'',
      id:null,
    })

    const confirmed = type =>{
      sendConfirm.value = type
      sendAsOwn.value = false
      showModal.value = true
    }
    
    const sendTmsLoading = ref(false)
    const sendToTMS = async () => {
      if (sendTmsLoading.value) return
      sendTmsLoading.value = true
      correctFormTms.value.type = sendConfirm.value
      try {
        await new Promise((resolve, reject) => {
          emit('sendTMS', {
            type: correctFormTms.value.type,
            sendAsOwn: correctFormTms.value.type === 'candidate' && sendAsOwn.value,
            resolve,
            reject,
          })
        })
        showModal.value = false
        sendConfirm.value = null
        correctFormTms.value.inn_driver = ''
        correctFormTms.value.type = ''
        sendAsOwn.value = false
      } catch {
        // The store already displays the API error. Keep the confirmation open
        // so the user can retry after correcting data or a transient failure.
      } finally {
        sendTmsLoading.value = false
      }
    }

    const forms = ref({
      executors:{
        id:props.executor?.id,
        edo_id:props.executor?.edo_id || '',
      },
      drivers:{
        id:props.executor?.driver?.id,
        phone:props.executor?.driver?.phone,
        birthday:props.executor?.driver?.birthday,
        passport:props.executor?.driver?.passport,
        license:props.executor?.driver?.license,
        inn:props.executor?.driver?.inn,
        passport_issued:props.executor?.driver?.passport_issued,
        passport_date:props.executor?.driver?.passport_date,
      },
      cars:{
        id:props.executor?.car?.id,
        number:props.executor?.car?.number,
        vin:props.executor?.car?.vin,
        ownerPhone:props.executor?.car?.ownerPhone,
        brand_name:props.executor?.car?.security_info?.[0]?.avtocod_identifiers_brand_name
      },
      companies:{
        id:props.executor?.company?.id,
        name:props.executor?.company?.name,
        director:props.executor?.company?.director,
        ogrn:props.executor?.company?.ogrn,
        inn:props.executor?.company?.inn
      },
    })

    if(props.executor?.trailer){
      forms.value.trailers = {
        id:props.executor.trailer.id,
        number:props.executor.trailer.number,
        vin:props.executor.trailer.vin,
        ownerPhone:props.executor.trailer.ownerPhone,
        brand_name:props.executor.trailer.security_info?.[0]?.avtocod_identifiers_brand_name
      }
    }

    const openClose = btn =>{
      if(btn == 'redactDriver'){
        redactDriver.value = !redactDriver.value
        redactTrailer.value = false
        redactCompany.value = false
        redactCar.value = false
      }
      else if(btn == 'redactTrailer'){
        redactTrailer.value = !redactTrailer.value
        redactDriver.value = false
        redactCompany.value = false
        redactCar.value = false
      }
      else if(btn == 'redactCompany'){
        redactCompany.value = !redactCompany.value
        redactDriver.value = false
        redactTrailer.value = false
        redactCar.value = false
      }
      else if(btn == 'redactCar'){
        redactCar.value = !redactCar.value
        redactDriver.value = false
        redactTrailer.value = false
        redactCompany.value = false
      }
      else if(btn == 'redactExecutor'){
        redactExecutor.value = !redactExecutor.value
        redactDriver.value = false
        redactTrailer.value = false
        redactCompany.value = false
        redactCar.value = false
      }
    }

    const saveForm = async name =>{
      const saved = await saveExecutorForm(emit, { form: forms.value[name], model: name })
      if (!saved) return
      redactDriver.value = false
      redactTrailer.value = false
      redactCompany.value = false
      redactCar.value = false
      redactExecutor.value = false
    }

    const updateBank = (id) =>{
      const form = {
        id:props.executor.id,
        bank_detail_id:id,
      }
      emit('updateExecutor',{form,model:'executors'})
    }

    const getBrandName = item =>{
      return item?.security_info?.[0]?.avtocod_identifiers_brand_name || '-'
    }

    const externalId = item => item?.tms_id || item?.candidate_id || '-'

    const tmsObjectUrl = (resource, id) => `${TMS_WEB_URL}/dictionary/${resource}/${encodeURIComponent(String(id))}`

    const booleanLabel = value => {
      if (value === true) return 'Да'
      if (value === false) return 'Нет'
      return '-'
    }

    const innStatusLabel = driver => {
      const labels = {
        done: 'Проверен',
        failed: 'Ошибка проверки',
        pending: 'Ожидает проверки',
        processing: 'Проверяется',
      }
      return labels[driver?.inn_check_status] || '-'
    }

    const copyValue = value => value === undefined || value === null || value === '' ? null : String(value)

    const copyBlock = async (title, fields) => {
      const lines = fields
        .map(([label, value]) => {
          const formatted = copyValue(value)
          return formatted ? `${label}: ${formatted}` : null
        })
        .filter(Boolean)
      if (!lines.length || !navigator.clipboard?.writeText) return
      try {
        await navigator.clipboard.writeText(`${title}\n${lines.join('\n')}`)
        toaster.success('Скопировано')
      } catch (error) {
        console.error('[ExecutorTripInfo] copy failed', error)
      }
    }

    const copyCar = (car, title = 'Автомобиль') => copyBlock(title, [
      ['Марка', getBrandName(car)],
      ['Номер', car?.number],
      ['VIN', car?.vin],
      ['Телефон владельца', car?.ownerPhone],
      ['Техпаспорт', car?.techPassport],
      ['TMS/candidate ID', externalId(car)],
      ['GLONASS', booleanLabel(car?.glonass)],
    ])

    const copyTrailer = (trailer, title = 'Прицеп') => copyBlock(title, [
      ['Марка', getBrandName(trailer)],
      ['Номер', trailer?.number],
      ['VIN', trailer?.vin],
      ['Телефон владельца', trailer?.ownerPhone],
      ['Тип', trailer?.trailer_type_id],
      ['TMS/candidate ID', externalId(trailer)],
    ])

    const copyDriver = (driver, title = 'Водитель') => copyBlock(title, [
      ['ФИО', [driver?.last_name, driver?.first_name, driver?.surname].filter(Boolean).join(' ')],
      ['Телефон', driver?.phone],
      ['Дата рождения', driver?.birthday],
      ['Паспорт', driver?.passport],
      ['Кем выдан', driver?.passport_issued],
      ['Дата выдачи', driver?.passport_date],
      ['ВУ', driver?.license],
      ['ИНН', driver?.inn || driver?.generated_inn],
      ['TMS/candidate ID', externalId(driver)],
      ['Проверка ИНН', innStatusLabel(driver)],
    ])

    const copyCompany = (company, bankDetails) => copyBlock('Компания', [
      ['Название', company?.name],
      ['Директор', company?.director],
      ['ОГРН', company?.ogrn],
      ['ИНН', company?.inn],
      ['Банк', bankDetails?.bank_name],
    ])

    const copyAll = (executorData, title) => copyBlock(title, [
      ['Авто', [getBrandName(executorData?.car), executorData?.car?.number, executorData?.car?.vin].filter(Boolean).join(' | ')],
      ['Прицеп', executorData?.trailer ? [getBrandName(executorData.trailer), executorData.trailer.number, executorData.trailer.vin].filter(Boolean).join(' | ') : null],
      ['Водитель', [executorData?.driver?.last_name, executorData?.driver?.first_name, executorData?.driver?.surname].filter(Boolean).join(' ')],
      ['Телефон водителя', executorData?.driver?.phone],
      ['ВУ', executorData?.driver?.license],
      ['ИНН', executorData?.driver?.inn || executorData?.driver?.generated_inn],
    ])

    const hasExternalNumber = item =>{
      if (!item) return false
      return Boolean(item.tms_id || item.candidate_id)
    }

    const statusClass = success =>{
      return success ? 'status-success' : 'status-warning'
    }

    const attorneyStatus = computed(()=>{
      if (props.trip.is_tms_attorney) {
        return { text: 'Добавлена в ТМС', success: true }
      }
      if (!props.executor && props.randomExecutor) {
        return { text: 'Добавлена заглушка', success: true }
      }
      if (props.executor && props.randomExecutor) {
        return { text: 'Отправлена только заглушка', success: false }
      }
      return { text: 'Не добавлена в ТМС', success: false }
    })

    const sendForm = ({form,model}) =>{
      emit('updateExecutor',{form,model})
    }

    const deleteExecutor = ()=>{
      store.dispatch('cargos/updateStatus',{link:route.params.id+'/executor/delete'})
    }

    const sendOrderLoading = ref(false)
    const sendOrder = async () => {
      if (sendOrderLoading.value) return
      sendOrderLoading.value = true
      try {
        await new Promise((resolve, reject) => {
          emit('sendOrder', { resolve, reject })
        })
      } catch (e) {
        // ошибку показывает родитель
      } finally {
        sendOrderLoading.value = false
      }
    }

    const existTmsId = (name)=>{
      if(props.trip?.trip_id?.length === 10){
        return props.executor?.[name]?.tms_id
      }else{
        return props.executor?.[name]?.candidate_id
      }
    }
    const sendTmsSuccess = computed(()=>{
      const car = props.executor?.car
      const driver = props.executor?.driver
      const trailer = props.executor?.trailer
      if (car?.tms_id && driver?.tms_id){
        if (trailer && trailer.tms_id){
          return true
        }
      }
      return false
    })
    const showTmsBlock = computed(()=>{
      if (!props.executor) return false
      const statusName = props.trip?.work_status?.name
      if (statusName === 'Закрыт') return false
      if (statusName !== 'В пути') return true
      return !props.trip.is_tms_candidate || !props.trip.is_tms_attorney
    })

    const canViewTmsLog = computed(() => store.getters.hasPermission('tms.action_log'))
    const tmsLastError = ref(null)
    const tmsLogLink = computed(() => {
      const tripId = props.trip?.trip_id
      return tripId
        ? `/admin/tms-action-log?trip_id=${encodeURIComponent(tripId)}`
        : '/admin/tms-action-log'
    })
    const loadTmsLastError = async (tripId) => {
      tmsLastError.value = null
      if (!canViewTmsLog.value || !tripId) return
      try {
        tmsLastError.value = await fetchTmsLastErrorByTrip(tripId)
      } catch (e) {
        // ошибка загрузки не блокирует карточку рейса
      }
    }
    watch(() => props.trip?.trip_id, (tripId) => { loadTmsLastError(tripId) }, { immediate: true })
    const statusCar = computed(()=> props.executor?.car || props.randomExecutor?.car)
    const statusTrailer = computed(()=> props.executor?.trailer || props.randomExecutor?.trailer)
    const statusDriver = computed(()=> props.executor?.driver || props.randomExecutor?.driver)

    const driverInnChecking = computed(() =>
      ['pending', 'processing'].includes(props.executor?.driver?.inn_check_status)
    )

    const driverInnCheckingText = computed(() => {
      const s = props.executor?.driver?.inn_check_status
      if (s === 'pending') return '⏳ ИНН проверяется в ФНС...'
      return `⚙️ Идёт проверка (попытка ${props.executor?.driver?.inn_check_attempts || 1}/5)...`
    })

    const innRecheckBusy = ref(false)

    function formatInnDate(value) {
      if (!value) return ''
      try {
        return new Date(value).toLocaleDateString('ru-RU')
      } catch {
        return ''
      }
    }

    async function recheckDriverInn() {
      const driverId = props.executor?.driver?.id
      if (!driverId || innRecheckBusy.value) return
      innRecheckBusy.value = true
      try {
        await store.dispatch('apiStorage/recheckInn', { id: driverId })
        await store.dispatch('apiStorage/pollInnStatus', {
          id: driverId,
          initialDelayMs: 5000,
          capDelayMs: 30000,
          maxTotalMs: 600000,
          onUpdate: async () => {
            await store.dispatch('cargos/getTrip', { trip_id: props.trip.id })
          },
        })
      } catch (e) {
        console.error('[ExecutorTripInfo] recheckDriverInn failed', e)
      } finally {
        innRecheckBusy.value = false
      }
    }

    return{
      sendOrder,
      sendOrderLoading,
      updateBank,
      changeBank,
      getBrandName,
      externalId,
      tmsObjectUrl,
      booleanLabel,
      innStatusLabel,
      copyCar,
      copyTrailer,
      copyDriver,
      copyCompany,
      copyAll,
      hasExternalNumber,
      statusClass,
      attorneyStatus,
      sendForm,
     showTmsBlock,
     statusCar,
     statusTrailer,
     statusDriver,
     driverInnChecking,
     driverInnCheckingText,
     innRecheckBusy,
     recheckDriverInn,
     formatInnDate,
     sendTmsSuccess,
     existTmsId,
     canViewTmsLog,
     tmsLastError,
     tmsLogLink,
     correctFormTms,
     sendConfirm,
     sendAsOwn,
     showModal,
     showRandomExecutor,
     confirmed,
     delConfirm,
     deleteExecutor,
     redactDriver,
     redactCompany,
     redactTrailer,
      redactCar,
      redactExecutor,
     openClose,
     saveForm,
     forms,
      sendToTMS,
      sendTmsLoading,
      application,
     //  application:computed(()=>store.state.application.tripPage.comments),
     // resync
     isAdmin,
     showResyncModal,
     resyncLoading,
     resyncApplying,
     resyncResult,
     resyncError,
     resyncButtonDisabled,
     diffFields,
     hasDiff,
     canApply,
     formatValue: formatResyncValue,
     openResyncPreview,
     applyResync,
     closeResyncModal,
    }
  }
};
</script>

<style scoped>
.trip-main{
  padding: 18px 10px;
  margin-top: 15px;
  border-top: 1px solid #ddd;
}

.executor-header{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.executor-header h4{
  margin: 0;
}

.executor-actions,
.section-actions{
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 10px;
}

.executor-grid{
  display: grid;
  grid-template-columns: repeat(4, minmax(210px, 1fr));
  gap: 10px;
}

.executor-section{
  border: 1px solid #d8d8d8;
  border-radius: 6px;
  padding: 10px;
  min-width: 0;
}

.section-header{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 30px;
  margin-bottom: 8px;
}

.section-header-actions{
  display: flex;
  align-items: center;
  gap: 5px;
}

.section-header h5{
  margin: 0;
  font-size: 14px;
}

.field-row{
  display: grid;
  grid-template-columns: minmax(80px, 38%) minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  min-height: 28px;
  border-bottom: 1px solid #eee;
  font-size: 13px;
}

.field-row span{
  color: #666;
}

.field-row strong{
  min-width: 0;
  overflow-wrap: anywhere;
  font-weight: 500;
}

.form-input{
  width: 100%;
  min-width: 0;
  padding: 3px 5px;
  border-radius: 3px;
  border: 1px solid #ccc;
  box-sizing: border-box;
}

.warning-text{
  margin: 8px 0 0;
  color: #666;
  font-size: 12px;
}

.random-accordion{
  margin-top: 12px;
}

.accordion-toggle{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  border: 1px solid #d8d8d8;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
}

.accordion-toggle span{
  color: #666;
}

.accordion-toggle strong{
  color: #0b66c3;
  font-weight: 500;
}

.random-executor-grid{
  margin-top: 10px;
  grid-template-columns: repeat(3, minmax(210px, 1fr));
}

.integration-statuses{
  margin-top: 12px;
  padding: 10px;
  border: 1px solid #d8d8d8;
  border-radius: 6px;
}

.integration-statuses h5{
  margin: 0 0 8px;
  font-size: 14px;
}

.status-grid{
  display: grid;
  grid-template-columns: repeat(5, minmax(150px, 1fr));
  gap: 8px;
}

.status-row{
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  font-size: 13px;
}

.status-row > span{
  color: #666;
}

.status-row strong{
  overflow-wrap: anywhere;
  font-weight: 500;
}

.status-success{
  color: #2f7d32;
}

.status-warning{
  color: #C33245;
}

.add-link{
  margin-left: 8px;
  color: #4398f0;
  text-decoration: underline;
  cursor: pointer;
  white-space: nowrap;
}

.send-order-block{
  margin-top: 12px;
}

.flex-row{
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 12px;
}

.send-tms-candidat{
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.tms-button-send{
  margin-top: 16px;
  padding: 10px;
  border: 1px solid #d8d8d8;
  border-radius: 6px;
  text-align: center;
}

.tms-button-send h4{
  margin: 0 0 8px;
}

.tms-block-info h5{
  margin: 0 0 5px;
}

.tms-error-message{
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px solid #f1b7bd;
  border-radius: 6px;
  background: #fff6f7;
  color: #9f2333;
  text-align: left;
}

.tms-error-message strong{
  display: block;
  margin-bottom: 4px;
}

.tms-error-message p{
  margin: 0;
  line-height: 1.35;
}

.tms-error-message small{
  display: block;
  margin-top: 6px;
  color: #7c1c29;
}

.attorey-message{
  margin-top: 10px;
  font-size: 12px;
  color: #C33245;
}

.attorey-message p{
  margin: 0 0 3px;
}

.link-executor{
  color: #0b66c3;
  font-size: 14px;
  border-bottom: 1px solid;
  cursor: pointer;
}

.change-button {
  padding: 5px 12px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.save-button {
  margin-right: 5px;
  margin-top: 2px;
  padding: 5px 12px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.disabled-button{
  margin-right: 5px;
  margin-top: 2px;
  padding: 5px 12px;
}

.delete-btn {
  padding: 5px 8px;
  border: 1px solid #C33245;
  border-radius: 4px;
  background-color: #C33245;
  color: #fff;
  cursor: pointer;
}

.redact-btn {
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
  background: #fff;
  cursor: pointer;
}

.copy-btn {
  padding: 4px 8px;
  border: 1px solid #007bff;
  border-radius: 4px;
  background: #fff;
  color: #007bff;
  cursor: pointer;
  white-space: nowrap;
}

.copy-btn:hover {
  background: #eef6ff;
}

.copy-all-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}

.copy-all-btn {
  background: #007bff;
  color: #fff;
}

.tms-link {
  color: #0b66c3;
  text-decoration: underline;
  overflow-wrap: anywhere;
}

.modal-content{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.send-as-own-option {
  align-items: center;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  gap: 8px;
  margin: 4px 0 0;
}

.send-as-own-option input {
  height: 16px;
  margin: 0;
  width: 16px;
}

.send-as-own-hint {
  color: #6b7280;
  font-size: 12px;
  margin: 6px 0 12px;
  max-width: 320px;
  text-align: center;
}

@media (max-width: 1200px){
  .executor-grid{
    grid-template-columns: repeat(2, minmax(220px, 1fr));
  }

  .status-grid{
    grid-template-columns: repeat(2, minmax(180px, 1fr));
  }
}

@media (max-width: 720px){
  .executor-grid{
    grid-template-columns: 1fr;
  }

  .status-grid{
    grid-template-columns: 1fr;
  }

  .flex-row{
    flex-direction: column;
  }
}

.inn-edit-cell{
  width: 100%;
  min-width: 0;
}

.inn-status-cell{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.inn-checking{
  color: #b78900;
  font-weight: 500;
}

.inn-fallback-small{
  width: 100%;
  font-size: 11px;
  color: #999;
}

.inn-badge{
  padding: 1px 6px;
  border-radius: 3px;
  font-size: 11px;
  font-weight: 500;
  border: 1px solid currentColor;
  white-space: nowrap;
}

.inn-badge-success{ color: #28a745; }
.inn-badge-warning{ color: #b78900; }
.inn-badge-error{ color: #dc3545; }

.inn-meta{
  font-size: 11px;
  color: #888;
}

.inn-link-btn{
  padding: 2px 8px;
  border: 1px solid #007bff;
  border-radius: 4px;
  background: #fff;
  color: #007bff;
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;
}

.inn-link-btn:disabled{
  color: #ccc;
  border-color: #ccc;
  cursor: not-allowed;
}

.tms-resync-block{
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px dashed #d8d8d8;
  text-align: left;
}

.resync-button{
  min-width: 220px;
}

.resync-disabled-hint{
  margin: 6px 0 0;
  font-size: 12px;
  color: #999;
}

.resync-modal-content{
  min-width: 460px;
  max-width: 560px;
  text-align: left;
}

.resync-modal-content h4{
  margin: 0 0 4px;
}

.resync-modal-subtitle{
  color: #666;
  font-size: 12px;
  margin-bottom: 12px;
}

.resync-state{
  padding: 12px 0;
  text-align: center;
}

.resync-state-loading p{
  color: #666;
  margin: 0;
}

.resync-state-error strong{
  display: block;
  color: #9f2333;
  margin-bottom: 6px;
}

.resync-state-error p{
  margin: 0 0 10px;
  color: #9f2333;
  overflow-wrap: anywhere;
}

.resync-banner{
  padding: 8px 10px;
  border-radius: 4px;
  margin-bottom: 10px;
}

.resync-banner-success{
  background: #f0f9f0;
  border: 1px solid #b7dfb7;
  color: #2f7d32;
}

.resync-section{
  margin-bottom: 12px;
}

.resync-section h5{
  margin: 0 0 6px;
  font-size: 13px;
  color: #333;
}

.resync-executor-card{
  display: flex;
  gap: 8px;
  align-items: baseline;
  padding: 6px 8px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  background: #fafafa;
  font-size: 13px;
  overflow-wrap: anywhere;
}

.resync-diff{
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  padding: 6px 8px;
  background: #fafafa;
}

.resync-diff-row{
  display: grid;
  grid-template-columns: 160px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  border-bottom: 1px solid #eee;
  font-size: 13px;
}

.resync-diff-row:last-child{
  border-bottom: none;
}

.resync-diff-row > span{
  color: #666;
}

.resync-diff-row strong{
  font-weight: 500;
  overflow-wrap: anywhere;
}

.diff-current{ color: #9f2333; }
.diff-arrow{ color: #999; padding: 0 6px; }
.diff-planned{ color: #2f7d32; }

.resync-tags{
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.resync-tag{
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 11px;
  font-weight: 500;
  border: 1px solid currentColor;
}

.resync-tag-applied{ color: #28a745; }
.resync-tag-skipped{ color: #999; }

.resync-warnings{
  padding: 8px 10px;
  border: 1px solid #f1d6a4;
  border-radius: 4px;
  background: #fff8ec;
}

.resync-warning-list{
  margin: 0;
  padding-left: 18px;
  color: #8a6a14;
  font-size: 12px;
  line-height: 1.4;
}

.resync-warning-list li{
  margin-bottom: 2px;
  overflow-wrap: anywhere;
}

.resync-actions{
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 14px;
}

@media (max-width: 720px){
  .resync-modal-content{
    min-width: 280px;
  }

  .resync-diff-row{
    grid-template-columns: 1fr;
    gap: 2px;
  }
}
</style>
